module.exports = __webpack_public_path__ + "static/media/HomeStoryImage8.1b2805e9.jpg";